import { render } from "./ViewPracticeResults.vue?vue&type=template&id=5b1eea62&scoped=true"
import script from "./ViewPracticeResults.vue?vue&type=script&lang=js"
export * from "./ViewPracticeResults.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-results.css?vue&type=style&index=0&id=5b1eea62&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1eea62"]])

export default __exports__